// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__MMvqk","subtitle":"styles_subtitle__3ruVy","titles":"styles_titles__37XpB"};